module.exports = __webpack_public_path__ + "img/pic_bmou_s.9f2cf62b.png";